import { usePersEventCatalogData } from './composables/usePersEventCatalogData';
import useHeader from './header';

export default function useCatalog({ adaptive, store, router }) {
  const { getHeader } = useHeader({ store, router });
  const { filtersData, listingData } = usePersEventCatalogData({ store, router, adaptive });

  const sendProductsAppearCatalog = (products) => {
    const mappedProducts = products.map(({ index, product }) => ({
      id: product.id,
      position: index + 1,
      price: product?.price.discountPrice,
      discount: product?.price.discountAmount,
    })).sort((a, b) => a.position - b.position);

    const body = {
      listing: listingData.value,
      filters: filtersData.value,
      products: mappedProducts,
    };

    return store.$apiBFF.sendPersEvent({ type: 'catalog/products-appear-catalog', data: { header: getHeader(), body } });
  };

  return {
    sendProductsAppearCatalog,
  };
}
